import { Injectable } from "@angular/core";

import { TaggerList } from "../../models";

@Injectable()
export class TaggerService {

	constructor(
	) { }

	public getCurrentRoles(roles: string[]) {
		const localRoles: TaggerList[] = [];
		for (const role of roles) {
			localRoles.push({display: role, value: role});
		}
		return localRoles;
	}

	public setRoles(roles: TaggerList[]) {
		return  roles.map((a: TaggerList) => {
			return a.value;
		});
	}
}
